import { makeStyles } from '@mui/styles';
import React from 'react';

const useStyles = makeStyles({
  requiredLabel: {
    top: -3,
    marginLeft: 3,
    fontSize: '20px',
    fontWeight: 'bold',
    lineHeight: 1,
    color: '#e20000',
  },
});

const RequiredIndicator = () => {
  const classes = useStyles();

  return <span className={classes.requiredLabel}>{'*'}</span>;
};

export default RequiredIndicator;
